import { render, staticRenderFns } from "./LoginAttemptsWarning.vue?vue&type=template&id=36a25b44&scoped=true&"
import script from "./LoginAttemptsWarning.vue?vue&type=script&lang=js&"
export * from "./LoginAttemptsWarning.vue?vue&type=script&lang=js&"
import style0 from "./LoginAttemptsWarning.vue?vue&type=style&index=0&id=36a25b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a25b44",
  null
  
)

export default component.exports